import { TankStock } from "../models/TankStock";

interface FuelSpec {
    fuel_class: string
    fuel_grade: string
    iso_grade: string
    density_15_max: number
    density_20_max: number
    sulphur_min: number
    sulphur_max: number
    viscosity_50_max: number
    viscosity_40_max: number
    viscosity_40_min: number
    viscosity_20_max: number
    lcv: number
    e_value: number
    wtt_emission_factor: number
    cf_co2: number
    cf_ch4: number
    cf_n2o: number
    c_slip: number
}

const fuelSpecs: FuelSpec[] = [
  {
    fuel_class: "fossil",
    fuel_grade: "hfo",
    iso_grade: "RME 180",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: 0.5,
    sulphur_max: null,
    viscosity_50_max: 180.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "hfo",
    iso_grade: "RMG180",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: 0.5,
    sulphur_max: null,
    viscosity_50_max: 180.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "hfo",
    iso_grade: "RMG 380",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: 0.5,
    sulphur_max: null,
    viscosity_50_max: 380.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "hfo",
    iso_grade: "RMG 500",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: 0.5,
    sulphur_max: null,
    viscosity_50_max: 500.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "hfo",
    iso_grade: "RMG 700",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: 0.5,
    sulphur_max: null,
    viscosity_50_max: 700.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "hfo",
    iso_grade: "RMK 380",
    density_15_max: 1010.0,
    density_20_max: null,
    sulphur_min: 0.5,
    sulphur_max: null,
    viscosity_50_max: 380.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "hfo",
    iso_grade: "RMK 500",
    density_15_max: 1010.0,
    density_20_max: null,
    sulphur_min: 0.5,
    sulphur_max: null,
    viscosity_50_max: 500.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "hfo",
    iso_grade: "RMK 700",
    density_15_max: 1010.0,
    density_20_max: null,
    sulphur_min: 0.5,
    sulphur_max: null,
    viscosity_50_max: 700.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "lfo",
    iso_grade: "RMA 10",
    density_15_max: 920.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: 10.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "lfo",
    iso_grade: "RMB 30",
    density_15_max: 960.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: 30.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "lfo",
    iso_grade: "RMD 80",
    density_15_max: 975.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: 80.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "mgo",
    iso_grade: "DMX",
    density_15_max: null,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 5.5,
    viscosity_40_min: 1.4,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "mgo",
    iso_grade: "DMA",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "mgo",
    iso_grade: "DFA",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "mgo",
    iso_grade: "DMZ",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "mgo",
    iso_grade: "DFZ",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "mgo",
    iso_grade: "DMB",
    density_15_max: 900.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 11.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "mdo",
    iso_grade: "DMX",
    density_15_max: null,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 5.5,
    viscosity_40_min: 1.4,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "mdo",
    iso_grade: "DMA",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "mdo",
    iso_grade: "DFA",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "mdo",
    iso_grade: "DMZ",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "mdo",
    iso_grade: "DFZ",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "mdo",
    iso_grade: "DMB",
    density_15_max: 900.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 11.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "RME 180",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 180.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "RMG180",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 180.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "RMG 380",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 380.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "RMG 500",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 500.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "RMG 700",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 700.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "RMK 380",
    density_15_max: 1010.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 380.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "RMK 500",
    density_15_max: 1010.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 500.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "RMK 700",
    density_15_max: 1010.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 700.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "RMA 10",
    density_15_max: 920.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 10.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "RMB 30",
    density_15_max: 960.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 30.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "RMD 80",
    density_15_max: 975.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 80.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "DMX",
    density_15_max: null,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 5.5,
    viscosity_40_min: 1.4,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "DMA",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "DFA",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "DMZ",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "DFZ",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsfo2020",
    iso_grade: "DMB",
    density_15_max: 900.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 11.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulslfo2020",
    iso_grade: "RMA 10",
    density_15_max: 920.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 10.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulslfo2020",
    iso_grade: "RMB 30",
    density_15_max: 960.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 30.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulslfo2020",
    iso_grade: "RMD 80",
    density_15_max: 975.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: 80.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsmdo2020",
    iso_grade: "DMX",
    density_15_max: null,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 5.5,
    viscosity_40_min: 1.4,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsmdo2020",
    iso_grade: "DMA",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsmdo2020",
    iso_grade: "DFA",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsmdo2020",
    iso_grade: "DMZ",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsmdo2020",
    iso_grade: "DFZ",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsmdo2020",
    iso_grade: "DMB",
    density_15_max: 900.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 11.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsmgo2020",
    iso_grade: "DMX",
    density_15_max: null,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 5.5,
    viscosity_40_min: 1.4,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsmgo2020",
    iso_grade: "DMA",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsmgo2020",
    iso_grade: "DFA",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsmgo2020",
    iso_grade: "DMZ",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsmgo2020",
    iso_grade: "DFZ",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ulsmgo2020",
    iso_grade: "DMB",
    density_15_max: 900.0,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: 0.1,
    viscosity_50_max: null,
    viscosity_40_max: 11.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.206,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "RME 180",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 180.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "RMG180",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 180.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "RMG 380",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 380.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "RMG 500",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 500.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "RMG 700",
    density_15_max: 991.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 700.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "RMK 380",
    density_15_max: 1010.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 380.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "RMK 500",
    density_15_max: 1010.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 500.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "RMK 700",
    density_15_max: 1010.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 700.0,
    viscosity_40_max: null,
    viscosity_40_min: 21.0,
    viscosity_20_max: null,
    lcv: 40500.0,
    e_value: null,
    wtt_emission_factor: 13.5,
    cf_co2: 3.114,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "RMA 10",
    density_15_max: 920.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 10.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "RMB 30",
    density_15_max: 960.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 30.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "RMD 80",
    density_15_max: 975.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 80.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "DMX",
    density_15_max: null,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 5.5,
    viscosity_40_min: 1.4,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "DMA",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "DFA",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "DMZ",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "DFZ",
    density_15_max: 890.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 6.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlsfo2020",
    iso_grade: "DMB",
    density_15_max: 900.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: null,
    viscosity_40_max: 11.0,
    viscosity_40_min: 2.0,
    viscosity_20_max: null,
    lcv: 42700.0,
    e_value: null,
    wtt_emission_factor: 14.4,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlslfo2020",
    iso_grade: "RMA 10",
    density_15_max: 920.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 10.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlslfo2020",
    iso_grade: "RMB 30",
    density_15_max: 960.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 30.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "vlslfo2020",
    iso_grade: "RMD 80",
    density_15_max: 975.0,
    density_20_max: null,
    sulphur_min: 0.1,
    sulphur_max: 0.5,
    viscosity_50_max: 80.0,
    viscosity_40_max: 20.0,
    viscosity_40_min: 3.0,
    viscosity_20_max: null,
    lcv: 41000.0,
    e_value: null,
    wtt_emission_factor: 13.2,
    cf_co2: 3.151,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "fossil",
    fuel_grade: "ethane",
    iso_grade: "Ethane",
    density_15_max: null,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: null,
    viscosity_50_max: null,
    viscosity_40_max: null,
    viscosity_40_min: null,
    viscosity_20_max: null,
    lcv: 46400.0,
    e_value: null,
    wtt_emission_factor: 18.5,
    cf_co2: 2.927,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "biofuel",
    fuel_grade: "hvo",
    iso_grade: "HVO",
    density_15_max: null,
    density_20_max: 780,
    sulphur_min: 0,
    sulphur_max: 0,
    viscosity_50_max: null,
    viscosity_40_max: 3.0,
    viscosity_40_min: null,
    viscosity_20_max: null,
    lcv: 44000.0,
    e_value: null,
    wtt_emission_factor: null,
    cf_co2: 3.115,
    cf_ch4: 5e-5,
    cf_n2o: 0.00018,
    c_slip: null,
  },
  {
    fuel_class: "biofuel",
    fuel_grade: "fame",
    iso_grade: "FAME",
    density_15_max: null,
    density_20_max: 885,
    sulphur_min: null,
    sulphur_max: null,
    viscosity_50_max: null,
    viscosity_40_max: null,
    viscosity_40_min: null,
    viscosity_20_max: 7.5,
    lcv: 37000.0,
    e_value: null,
    wtt_emission_factor: null,
    cf_co2: 2.834,
    cf_ch4: null,
    cf_n2o: null,
    c_slip: null,
  },
  {
    fuel_class: "biofuel",
    fuel_grade: "biodiesel",
    iso_grade: "Biodiesel",
    density_15_max: null,
    density_20_max: 885,
    sulphur_min: null,
    sulphur_max: null,
    viscosity_50_max: null,
    viscosity_40_max: null,
    viscosity_40_min: null,
    viscosity_20_max: 7.5,
    lcv: 37000.0,
    e_value: null,
    wtt_emission_factor: null,
    cf_co2: 2.834,
    cf_ch4: null,
    cf_n2o: null,
    c_slip: null,
  },
  {
    fuel_class: "biofuel",
    fuel_grade: "bio_lng",
    iso_grade: "Bio-LNG",
    density_15_max: null,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: null,
    viscosity_50_max: null,
    viscosity_40_max: null,
    viscosity_40_min: null,
    viscosity_20_max: null,
    lcv: 49100.0,
    e_value: null,
    wtt_emission_factor: 18.5,
    cf_co2: 2.750,
    cf_ch4: 0,
    cf_n2o: 0.00011,
    c_slip: null,
  },
  {
    fuel_class: null,
    fuel_grade: "other",
    iso_grade: null,
    density_15_max: null,
    density_20_max: null,
    sulphur_min: null,
    sulphur_max: null,
    viscosity_50_max: null,
    viscosity_40_max: null,
    viscosity_40_min: null,
    viscosity_20_max: null,
    lcv: null,
    e_value: null,
    wtt_emission_factor: null,
    cf_co2: null,
    cf_ch4: null,
    cf_n2o: null,
    c_slip: null,
  },
];

const fuelTypesToFuelClasses = {
  "hfo": "fossil",
  "lfo": "fossil",
  "mgo": "fossil",
  "mdo": "fossil",
  "ulsfo2020": "fossil",
  "ulslfo2020": "fossil",
  "ulsmdo2020": "fossil",
  "ulsmgo2020": "fossil",
  "vlsfo2020": "fossil",
  "vlslfo2020": "fossil",
  "ethane" : "fossil",
  "lpgp": "fossil",
  "lpgb": "fossil",
  "lng": "fossil",
  "methanol": "fossil",
  "ethanol": "biofuel",
  "hvo": "biofuel",
  "fame": "biofuel",
  'biodiesel' : 'biofuel',
  'bio_lng' : 'biofuel',
  "other": undefined,
};

const isFuelTypeMatch = (tankStock: Partial<TankStock>, fuelSpec: FuelSpec, fuelClass: string = 'fossil') => {
    if (fuelSpec.fuel_class !== fuelClass) return false;

    let densityMatches = true;
    let suphurMinMatches = !fuelSpec.sulphur_min;
    let suphurMaxMatches = !fuelSpec.sulphur_max;
    let viscosity50MaxMatches = true;
    let viscosity40MaxMatches = true;
    let viscosity40MinMatches = true;
    let viscosity20MaxMatches = true;

    if (fuelSpec.density_15_max) densityMatches = tankStock.density <= fuelSpec.density_15_max;
    if (fuelSpec.density_20_max) densityMatches = tankStock.density <= fuelSpec.density_20_max;
    if (fuelSpec.sulphur_min) suphurMinMatches = tankStock.sulphur_after_bunkering > fuelSpec.sulphur_min;
    if (fuelSpec.sulphur_max) suphurMaxMatches = tankStock.sulphur_after_bunkering <= fuelSpec.sulphur_max;
    if (fuelSpec.viscosity_50_max) viscosity50MaxMatches = tankStock.viscosity <= fuelSpec.viscosity_50_max;
    if (fuelSpec.viscosity_40_max) viscosity40MaxMatches = tankStock.viscosity <= fuelSpec.viscosity_40_max;
    if (fuelSpec.viscosity_40_min) viscosity40MinMatches = tankStock.viscosity > fuelSpec.viscosity_40_min;
    if (fuelSpec.viscosity_20_max) viscosity20MaxMatches = tankStock.viscosity <= fuelSpec.viscosity_20_max;

    return densityMatches && suphurMinMatches && suphurMaxMatches && viscosity50MaxMatches && viscosity40MaxMatches && viscosity40MinMatches && viscosity20MaxMatches;
}

const fuelSpecFromTankStock = (tankStock: Partial<TankStock>, availableFuelGrades: string[], fuelClass: string = 'fossil', scope): FuelSpec | null => {
    const fuelSpecData = scope.fuelSpecDefaults || fuelSpecs;
    const availableFuelSpecs = fuelSpecData.filter(fuelSpec => availableFuelGrades.includes(fuelSpec.fuel_grade));
    const matchingFuelTypes = availableFuelSpecs.filter(fuelSpec =>  isFuelTypeMatch(tankStock, fuelSpec, fuelClass));
    const fuelGradeHint = tankStock.fuel_grade;
    const hintResult = matchingFuelTypes.find(fuelSpec => fuelSpec.fuel_grade === fuelGradeHint);
    return hintResult || matchingFuelTypes[0] || null;
};

export { fuelSpecFromTankStock, fuelTypesToFuelClasses };
